import React, {useEffect, useState} from "react";
import axios from "axios";

export default function () {
  const [data, setData] = useState({});
  const [errors, setErrors] = useState();
  const [filterParams, setFilterParams] = useState({
    filter_unit: 'week'
  });

  const getData = () => {
    axios.get("dashboard/top-products", {params: filterParams}).then(res => {
      if (res.data.status === 'success') {
        setData(res.data);
      }
    }).catch(function (error) {
      if (error.response) {
        setErrors(error.response.data.errors || {});
      }
    });
  }

  useEffect(() => {
    getData()
  }, [...Object.values(filterParams)]);


  return (
    <div className="rounded bg-main-color px-5 mt-20">
      <div className="row">
        <div className="col-xl-12 mb-5 mb-xl-0">
          <div className="border-bottom">
            {/* shadow */}
            <div className="px-1 py-3 border-0">
              <div className="row align-items-center">
                <div>
                  <h3 className="mb-0 pt-3 text-muted ls-1 d-inline-block">
                    Top Products
                  </h3>
                  <div className="float-right chart-change">
                    <span className="mr-3 fs-4 fw-bold text-muted">Filter</span>
                    <select
                      className="form-control form-control-lg form-control-solid d-inline-block w-auto ml-2"
                      onChange={(e) => setFilterParams({
                        ...filterParams,
                        filter_unit: e.target.value
                      })}
                      title="Filter"
                      defaultValue="week"
                    >
                      <option key={1} value="day">Days</option>
                      <option key={2} value="week">Week</option>
                      <option key={3} value="month">Month</option>
                      <option key={4} value="quarter">Quarter</option>
                      <option key={5} value="year">Year</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12 mb-5">
          <div className="col-12 mb-5">
            <div className="order row">
              <table className="table align-middle table-row-dashed gy-5 no-footer">
                <thead>
                <tr>
                  <th className="p-0 py-5 pl-3">Id</th>
                  <th className="p-0 py-5 pl-3 min-w-60px">Image</th>
                  <th className="p-0 py-5 pl-3">Name</th>
                  <th className="p-0 py-5 pl-3">Shop</th>
                  <th className="p-0 py-5 pl-3 pr-3">Price</th>
                </tr>
                </thead>
                <tbody>
                {
                  data?.top_products?.map((item, key) => {
                    return (
                      <tr key={key} className="col-xxl-4 col-xl-6 p-10 mb-lg-0 mb-10">
                        <td
                          className="fs-6 text-muted pl-3"
                          title="id"
                        >
                          {item?.id}
                        </td>
                        <td
                          className="color-primary cursor-pointer pl-3"
                          title="image"
                        >
                          <div className={`image${!item?.image?.url ? ' no-image' : ''}`}>
                            <img className={`w-100${!item?.image?.url ? ' opacity-25' : ''}`}
                                 src={item?.image?.url} alt=""/>
                          </div>
                        </td>
                        <td
                          className="fs-6 text-muted"
                          title="name"
                        >
                          {item?.name}
                        </td>
                        <td
                          className="fs-6 text-muted"
                          title="shop"
                        >
                          {item?.shop}
                        </td>
                        <td
                          className="fs-6 text-muted"
                          title="price"
                        >
                          {item?.price}
                        </td>
                      </tr>
                    )
                  })
                }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}